import React from 'react';

import Container from './Container.jsx';
import { default as _TypeConfig } from './TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function Logo(props) {
    const config = props.config || {};
    let blockProps = {};
    const blockConfig = config.config;
    if (blockConfig && blockConfig.Block) {
        blockProps = blockConfig.Block;
    }
    const data = props.data || {};
    let company = '';
    if (data.Gallery) {
        company = data.Gallery.Company;
    }
    const styleguide = data.Styleguide || {};
    let image;
    if (!Utilities.isNullOrWhitespace(styleguide.LogoUrl)) {
        const style = {
            maxWidth: '564px'
        };
        let temp;
        for (let id in blockProps) {
            temp = blockProps[id];
            if (Utilities.isNullOrWhitespace(temp)) {
                continue;
            }
            if (temp) {
                if (temp.value != undefined) {
                    if (temp.value.length > 0) {
                        style[id] = `${temp.value}${temp.unit}`;
                    }
                } else {
                    style[id] = temp;
                }
            }
        }

        let height, width;
        if (props.collateralType === 0 || props.collateralType === 3) {
            const widthClamp = 564;
            if (style.maxHeight && style.maxWidth) {
                //left/centered/right
                if (style.maxHeight.indexOf('px') > -1 && style.maxWidth.indexOf('%') > -1) {
                    let maxHeight = parseFloat(style['maxHeight'], 10);
                    maxHeight = Math.min(maxHeight, styleguide.LogoHeight);
                    const ratioY = maxHeight / styleguide.LogoHeight;
                    width = Math.floor(ratioY * styleguide.LogoWidth);
                    width = Math.min(width, widthClamp);
                }
                //classic
                else if (style.maxHeight.indexOf('px') > -1 && style.maxWidth.indexOf('px') > -1) {
                    const maxHeight = parseFloat(style['maxHeight'], 10);
                    let maxWidth  = parseFloat(style['maxWidth'], 10);
                    maxWidth = Math.min(maxWidth, widthClamp);

                    const ratioX = maxWidth / styleguide.LogoWidth;
                    const ratioY = maxHeight / styleguide.LogoHeight;
                    const ratio = ratioX < ratioY ? ratioX : ratioY;
                    width = Math.floor(styleguide.LogoWidth * ratio);
                    height = Math.floor(styleguide.LogoHeight * ratio);
                }
                else {
                    //abandon earth
                }
            }
        }

        image = (
            <img
                alt={company || ''}
                border="0"
                //height={height} //ignore
                src={styleguide.LogoUrl}
                style={style}
                width={width}
            />
        );
    } else {
        const style = { color: '#434343', fontSize: '16px', lineHeight: '22px' };
        if (styleguide.HeaderFont) {
            style.fontFamily = styleguide.HeaderFont.FontFamily;
        }
        image = <div className="text-right2" style={style}>{company}</div>;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            style={{ lineHeight: '0pt' }}
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                <td>
                    {image}
                    {props.builder && Utilities.Builder.dragOutline()}
                </td>
            </tr>
        </Container>
    );
}

const TypeConfig = {
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Layout',
                options: [
                    _TypeConfig.options.firstPageOnly(group),
                    {
                        display: 'Maximum Width',
                        fullWidth: true,
                        group,
                        name: 'maxWidth',
                        options: _TypeConfig.dropdown.measurement(true),
                        type: 'measurement-slider'
                    },
                    {
                        display: 'Maximum Height',
                        fullWidth: true,
                        group,
                        name: 'maxHeight',
                        options: _TypeConfig.dropdown.measurement(true),
                        type: 'measurement-slider'
                    }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('block', undefined, {}, { title: 'Logo Alignment' })
    }
};

export {
    Logo as Component,
    TypeConfig
};